import React from 'react'
import { Flex } from '@mobi/component-library/Common/Flex'
import { spacing } from '@mobi/component-library/Theme/Common'
import type { Acceptor, BettingType, Race, Selection } from '@mobi/betslip/types'
import { isRaceDetails } from '@mobi/betslip/helpers/typeGuards'
import { observeImmutable } from '@core/Components/HOCs'
import { ErrorMessage } from '@core/Components/Messages'
import { state$ as quickbetState$, QuickbetState } from '@core/Areas/Quickbet/driver'
import { RaceInfo } from './Components/RaceInfo/RaceInfo'
import { SelectionDisplay } from '../Common/SelectionDisplay'

export const RacingHeader: React.ComponentClass = observeImmutable(quickbetState$, ({ record }) => {
  const { selection, selectionDetails, bettingType, notificationType } =
    record.toJS() as QuickbetState
  if (!isRaceDetails(selectionDetails)) {
    return !PRODUCTION ? (
      <ErrorMessage>
        Selection details provided to RacingHeader was not compatible with RaceDetails
      </ErrorMessage>
    ) : null
  }
  return (
    <RacingHeaderComponent
      races={selectionDetails.races}
      acceptors={selectionDetails.acceptors}
      selection={selection}
      bettingType={bettingType}
      isRaceClosed={notificationType === 'RaceClosed'}
    />
  )
})

RacingHeader.displayName = 'RacingHeader'

export const RacingHeaderComponent: React.FC<
  {
    races: Race[]
    acceptors: Acceptor[]
    isRaceClosed?: boolean
  } & Required<Pick<QuickbetState, 'selection' | 'bettingType'>>
> = ({ races, acceptors, selection, bettingType, isRaceClosed }) => {
  // we only ever show information for one race. for win/place/trifecta, etc. that is the _only_ race
  // for double/quaddie/all-up, we show the first race, as that is when the pool will close
  const race = races[0]

  return (
    <Flex flexDirection='column' gap={spacing.sm}>
      {!!race && (
        <div data-testid='RaceInfo'>
          <RaceInfo
            key={race.key}
            race={race}
            bettingType={bettingType as BettingType}
            selection={selection as Selection}
            isRaceClosed={isRaceClosed}
          />
        </div>
      )}

      <SelectionDisplay selection={selection} races={races} acceptors={acceptors} />
    </Flex>
  )
}
